// Copyright (c) Siemens AG 2026 ALL RIGHTS RESERVED.
//
// mySiESTA

up.compiler('.input-group-prepend', (element) => {
  const $element = jQuery(element)

  $element.on('click', function() {
    const $maybeInput = $element.next()
    if ($maybeInput.is('input')) {
      $maybeInput.focus()
    } else {
      $element.closest('.input-group').find('input:eq(0)').focus()
    }
  })
})

up.compiler('.input-group-append', (element) => {
  const $element = jQuery(element)

  $element.on('click', function() {
    const $maybeInput = $element.prev()
    if ($maybeInput.is('input')) {
      $maybeInput.focus()
    } else {
      $element.closest('.input-group').find('input:eq(0)').focus()
    }
  })
})
